import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import * as RadixTabs from '@radix-ui/react-tabs';
import tabsStyles from './Tabs.styles.esm.js';
import { useTabsContext } from './TabsContext.esm.js';
import { cn } from '../../utils/cn.esm.js';

const TabsList = (_a) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    const { variant, inverse } = useTabsContext();
    const { list } = tabsStyles({ variant, inverse });
    return (jsx(RadixTabs.List, Object.assign({ className: cn(list(), className) }, props, { children: children })));
};
TabsList.displayName = "Tabs.List";

export { TabsList };
